import { types } from './actions';

const initialState = {
  isDeleting: false,
  isCopying: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DELETE_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    case types.DELETE_ERROR:
    case types.DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
      };
    case types.COPY_REQUEST:
      return {
        ...state,
        isCopying: true,
      };
    case types.COPY_ERROR:
    case types.COPY_SUCCESS:
      return {
        ...state,
        isCopying: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getScope = (state) => state.modules.opDefs.detailsPage;

export const getIsDeleting = (state) => getScope(state).isDeleting;

export const getIsDuplicating = (state) => getScope(state).isCopying;
